import React from 'react';
import { getOutfitFact, deleteOutfitFactById } from '../../../api/doc'
import PageList from '../../../components/PageListAPI'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function OutfitFactList({ history, match, location }) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='outfitPlan'
      title='Наряд заказ факт'
      columns={[
        { id: 'id', name: '№' },
        { id: 'date', name: 'Дата наряда', type: 'date', formatDate: 'LL' },
        { id: 'shortDescription', name: 'Краткое описание', },
        { id: 'name', name: 'Добавил', },
      ]}
      deleteItem={can(SLUGS.PROJECT.OUTFIT.FACT_DELETE)}
      idName='id'
      history={history}
      match={match}
      location={location}
      loadAPI={{
        param: {
          id: match.params.idProject
        },
        request: getOutfitFact,
      }}
      deleteAPI={deleteOutfitFactById(match.params.idProject)}
      headerInit={{
        sortBy:'date', 
        sortDirection:'desc',          
      }}
    />
  </div>
}